import React from 'react';
import styles from './InputDate.module.scss';
import classNames from 'classnames';

/* Assets */
import SVG from 'react-inlinesvg';
import arrow from '../../../assets/icons/icons-app-bar-back.svg';

interface InputDateSelectionProps {
  previous?: React.ReactNode;
  value: React.ReactNode;
  next?: React.ReactNode;
  handleNext: () => void;
  handlePrevious: () => void;
}

export const InputDateSelection: React.FC<InputDateSelectionProps> = ({
  previous,
  next,
  value,
  handleNext,
  handlePrevious,
}) => {
  const cx = classNames.bind(styles);

  return (
    <div className={styles.InputDateSelection}>
      <button
        disabled={!previous}
        onClick={() => {
          handlePrevious();
        }}
        className={cx(styles.DateSelectionBtn, styles.previous)}
      >
        <SVG src={arrow} className={cx(styles.arrow, styles.previous)} />
      </button>

      <div
        className={
          previous
            ? cx(styles.valueBox, styles.lowOpacity)
            : cx(styles.valueBox, styles.lowOpacity, styles.emptyBox)
        }
      >
        {previous && previous}
      </div>

      <div className={styles.valueBox}>{value}</div>

      <div className={cx(styles.valueBox, styles.lowOpacity)}>{next}</div>
      <button
        onClick={() => {
          handleNext();
        }}
        className={cx(styles.DateSelectionBtn, styles.next)}
      >
        <SVG src={arrow} className={cx(styles.arrow, styles.next)} />
      </button>
    </div>
  );
};
